// extracted by css-extract-rspack-plugin
export default {"FormControl_Validation":"search-input-module__FormControl_Validation__C2kHCxp"};